<app-header [class.collaspe]="isActive"></app-header>

<div class="main-container" [class.collaspe]="isActive" [class.switch-user-active]="isSwitchUser">
    <div class="hamburger-nav" (click)="hamburgerToggleDiv()"></div>
    <aside class="sidebar" [class.collaspe]="isActive">
        <app-sidebar-mailbox (onBoxSelected)="onBoxSelected($event)"></app-sidebar-mailbox>
    </aside>
    
    <main class="rht-container" [class.collaspe]="isActive">
        <app-mail-list *ngIf="mailData" [mailData]="mailData"></app-mail-list>
    </main>
</div>